import classNames from 'classnames';
import Image from '@next/image';

import { FooterLogo } from 'types/models/FooterLogo';
import PossibleLink from '@components/atoms/PossibleLink';
import createStyleVariables from 'utils/createStyleVariables';

import classes from './CopyrightFooter.module.scss';
import CopyrightBox from './CopyrightBox';

export type Props = {
  logos: Pick<FooterLogo, 'id' | 'description' | 'url' | 'file'>[];
  apiVersion?: string;
};

const CopyrightFooter = ({ logos, apiVersion = '' }: Props): JSX.Element => (
  <div className={classes.logosBox} data-nosnippet>
    <div
      className={classes.logosWrapper}
      style={createStyleVariables({
        columns: Math.ceil(logos.length / 2),
        gapMultiplier: logos.length <= 5 ? 8 : 2,
        justify: logos.length <= 5 ? 'flex-start' : 'space-between',
      })}
    >
      {logos.map(({ id, description, url, file }) => (
        <PossibleLink
          key={id}
          href={url}
          className={classNames(
            classes.logoWrapper,
            file.extension ? classes[file.extension as keyof typeof classes] : ''
          )}
          openInNewTab
        >
          <Image
            height={90}
            objectFit="contain"
            alt={description}
            resolveConfig={{
              preset: 'footer_logo',
              description,
              productName: 'footer_logo',
              extension: file.extension,
              name: file.basename,
              width: file.width,
              height: file.height,
            }}
          />
        </PossibleLink>
      ))}
    </div>
    <CopyrightBox apiVersion={apiVersion} />
  </div>
);

export default CopyrightFooter;
